import { html, toString } from './html.js';
import { me } from '../services/me.js';
import { space } from '../services/space.js';

/**
 * Seletor de espaço (topo das telas raiz) e a folha "Trocar de espaço".
 * Quem não faz parte de uma empresa não vê o seletor: o app tem um espaço só.
 */

export const initials = (name = '') =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toLocaleUpperCase('pt-BR'))
    .join('') || '·';

/** Botão do topo: avatar + nome do espaço. data-action="space" abre a folha. */
export function spaceButton() {
  if (!space.available) return '';
  const biz = space.current === 'business';
  const w = me.current?.workshop;
  return html`
    <button type="button" class="space-btn" data-action="space" aria-label="Trocar de espaço (agora: ${biz ? w?.name : 'Pessoal'})">
      ${biz
        ? html`<span class="avatar biz"><ion-icon name="storefront-outline" aria-hidden="true"></ion-icon></span>`
        : html`<span class="avatar">${initials(me.current?.user?.name)}</span>`}
      <span>${biz ? w?.name ?? 'Empresa' : 'Pessoal'}</span>
      <ion-icon class="chev" name="chevron-down" aria-hidden="true"></ion-icon>
    </button>`;
}

/** Abre a folha de troca. Ao escolher, salva e vai para o início do espaço. */
export function openSpaceSheet() {
  const w = me.current?.workshop;
  if (!w) return;
  const cur = space.current;
  const roleText = w.role === 'MANAGER' ? 'Responsável' : 'Profissional';
  const el = document.createElement('div');
  el.className = 'tc-sheet';
  el.innerHTML = toString(html`
    <div class="tc-sheet-panel" role="dialog" aria-modal="true" aria-label="Trocar de espaço">
      <div class="tc-sheet-grab" aria-hidden="true"></div>
      <div class="tc-sheet-head">
        <strong>Trocar de espaço</strong>
        <button type="button" class="tc-sheet-x" data-close aria-label="Fechar"><ion-icon name="close" aria-hidden="true"></ion-icon></button>
      </div>
      <div class="space-opts">
        <button type="button" class="space-opt ${cur === 'personal' ? 'on' : ''}" data-space="personal" aria-pressed="${cur === 'personal' ? 'true' : 'false'}">
          <span class="avatar lg">${initials(me.current?.user?.name)}</span>
          <span class="row-main"><span class="row-title">Pessoal</span><span class="row-sub">Sua garagem, lembretes e busca de empresas</span></span>
          ${cur === 'personal' ? html`<ion-icon class="check" name="checkmark-circle" aria-hidden="true"></ion-icon>` : ''}
        </button>
        <button type="button" class="space-opt biz ${cur === 'business' ? 'on' : ''}" data-space="business" aria-pressed="${cur === 'business' ? 'true' : 'false'}">
          <span class="avatar lg biz"><ion-icon name="storefront-outline" aria-hidden="true"></ion-icon></span>
          <span class="row-main"><span class="row-title">${w.name}</span><span class="row-sub">Empresa · ${roleText}</span></span>
          ${cur === 'business' ? html`<ion-icon class="check" name="checkmark-circle" aria-hidden="true"></ion-icon>` : ''}
        </button>
      </div>
      <p class="sheet-note">Cada espaço tem o próprio início e as próprias abas. O app abre no último espaço usado.</p>
    </div>`);
  const close = () => {
    el.remove();
    document.removeEventListener('keydown', onKey);
  };
  const onKey = (e) => e.key === 'Escape' && close();
  el.addEventListener('click', (e) => {
    if (e.target === el || e.target.closest('[data-close]')) return close();
    const opt = e.target.closest('[data-space]');
    if (!opt) return;
    close();
    if (opt.dataset.space === cur) return;
    space.set(opt.dataset.space);
    document.querySelector('ion-router').push(space.home(opt.dataset.space), 'root');
  });
  document.addEventListener('keydown', onKey);
  document.body.append(el);
  el.querySelector('.space-opt.on')?.focus();
}
